export {
  ConfirmationDialogComponent,
  ConfirmDialogData,
} from './confirmation-dialog.component';
